<template>
  <footer>
    <div>
      All content © copyright {{ new Date().getFullYear() }} Lane Clark & Peacock
      LLP. All rights reserved.
    </div>
    <div>
      <span class="terms-link" @click="showTerms">Terms and Conditions</span>
      <span class="terms-link" @click="showUserPolicy">User Privacy Policy</span>
      <span class="terms-link" @click="showPlayerPolicy">Player Privacy Policy</span>
    </div>
  </footer>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
@Component
export default class FooterBar extends Vue {

  public showTerms () {
    this.$store.commit('updateShowTerms', true);
    this.$store.commit('updateShowPlayerPolicy', false);
    this.$store.commit('updateShowUserPolicy', false);
  }
  
  public showPlayerPolicy() {
    this.$store.commit('updateShowTerms', false);
    this.$store.commit('updateShowPlayerPolicy', true);
    this.$store.commit('updateShowUserPolicy', false);
  }

  public showUserPolicy() {    
    this.$store.commit('updateShowTerms', false);
    this.$store.commit('updateShowPlayerPolicy', false);
    this.$store.commit('updateShowUserPolicy', true);
  }

}
</script>

<style lang="scss" scoped>
footer {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0%);
  // display: flex;
  align-items: center;
  justify-content: center;
  width: 60rem;
  height: 6rem;
  font-size: 1.3rem;
  line-height: 2rem;
  text-align: center;
  background-color: $themeBlack;
  z-index: -2;

  @include mix.responsive("sm") {
    position: fixed;
    font-size: 0.6rem;
  }
  .terms-link {
    display: inline-block;
    margin-left: 1rem;
    cursor: pointer;
    text-decoration: underline;
  }
}
</style>
